/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2026 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2026 - Finnish Meteorological Institute (FMI)
 * Copyright 2026 - The Norwegian Meteorological Institute (MET Norway)
 * */
import type { TafConfig } from '../../types';

export const fakeTafConfig: TafConfig = {
  forecastType: 'TAF',
  location_indicator_mwo: 'EHDB',
  locations: {
    EHAM: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Schiphol',
    },
    EHRD: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Rotterdam',
    },
    EHGG: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Eelde',
    },
    EHBK: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Maastricht',
    },
    EHLE: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Lelystad',
    },
    TNCB: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Bonaire',
    },
    EHAK: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Akureyri',
    },
    EHFD: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Farnborough',
    },
    EHDV: {
      validity_duration: 30,
      activity_period: 6,
      label: 'De Vries',
    },
    EHHW: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Holland',
    },
    EHKV: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Kavala',
    },
    EHMG: {
      validity_duration: 30,
      activity_period: 6,
      label: 'München',
    },
    EHMA: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Maastricht',
    },
    EHPG: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Petersburg',
    },
    EHQN: {
      validity_duration: 30,
      activity_period: 6,
      label: 'Queenstown',
    },
  },
  locationOrder: [
    'EHAM',
    'EHRD',
    'EHLE',
    'EHGG',
    'EHBK',
    'TNCB',
    'EHAK',
    'EHFD',
    'EHDV',
    'EHHW',
    'EHKV',
    'EHMG',
    'EHMA',
    'EHPG',
    'EHQN',
  ],
  autoTAFlocations: ['EHAM', 'EHRD', 'EHLE', 'EHGG', 'EHBK'],
  shouldEnableRemark: false,
};
